export default function initDialogs(callback) {
  const loginSuccessModalHtml = `
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content alert-pop">
      <div class="modal-body">
        <div class="inner">
          <div class="icon-alert confirm">
            <div class="text">
              <p><strong class="modal-face-success-text"></strong></p>
            </div>
          </div>
          <div class="btn-box full-1">
            <button
              type="button"
              class="btn btn-dark"
              id="ok"
            >
            ${this.$t('common.confirm')}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
    `,
    loginFailModalHtml = `
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content alert-pop">
        <div class="modal-body">
          <div class="inner">
            <div class="icon-alert nodata">
              <div class="text">
                <p style="white-space: pre-line;"><strong class="modal-face-fail-text"></strong></p>
                <p class="strong-text bull-none">(1/3)</p>
              </div>
            </div>
            <div class="btn-box full-1">
              <button
                type="button"
                class="btn btn-dark"
                id="fail-ok"
              >
                ${this.$t('common.confirm')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>`;
  //  login success
  const modalInit = document.createElement('div');
  modalInit.classList.add('modal');
  modalInit.setAttribute('id', 'modal-login-success');
  modalInit.setAttribute('style', 'display:none');
  modalInit.innerHTML = loginSuccessModalHtml;
  this.modalInit = modalInit;
  modalInit.querySelector('#ok').addEventListener('click', () => {
    this.toggleModal({type: 'success', modal: this.modalInit, flag: false});
    callback();
  });

  document.body.appendChild(modalInit);

  //   login fail
  const loginFailModalInit = document.createElement('div');
  loginFailModalInit.classList.add('modal');
  loginFailModalInit.setAttribute('id', 'modal-login-fail');
  loginFailModalInit.setAttribute('style', 'display: none');
  loginFailModalInit.innerHTML = loginFailModalHtml;
  this.loginFailModalInit = loginFailModalInit;
  document.body.appendChild(loginFailModalInit);
}
